$(document).ready(function() {
    var input = document.querySelector("#custom-phone");
    var iti = window.intlTelInput(input, {
        separateDialCode: true,
        initialCountry: "auto",
        geoIpLookup: function(success, failure) {
            $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
                var countryCode = (resp && resp.country) ? resp.country : "";
                success(countryCode);
            });
        },
    });
    input.addEventListener("countrychange", function() {

    });
    function getPhoneNumberWithCode() {
        return iti.getNumber(intlTelInputUtils.numberFormat.E164)
    }

    $("#custom-phone").on("blur",function(){
        const input = document.querySelector("#custom-phone");
        const iti = window.intlTelInputGlobals.getInstance(input);
        const hB = $(".field-contactform-phone > .help-block");
        const phoneErrorText = $('#phoneErrorText').val();

        if(iti.isValidNumber()) {
            $("#contactform-phone").val(getPhoneNumberWithCode());
            hB.text("");
        } else {
            hB.text(phoneErrorText);
        }

    });
});